import React from 'react';

export default function LinkIcon({ width = '8px', height = '14px' }) {
  return (
    <svg width="8px" height="14px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9.19 15.56">
      <polygon points="1.41 15.56 0 14.14 6.36 7.78 0 1.41 1.41 0 9.19 7.78 1.41 15.56" fill="#FFFFFF"></polygon>
    </svg>
  );
}
